import { useEffect, useState } from "react";
import api from "@/lib/api";

/** An <img> for endpoints that need the bearer token — the browser can't
    attach it to a plain src, so fetch the bytes and use an object URL. */
export const AuthImage = ({ path, alt = "", className = "", testId }) => {
  const [src, setSrc] = useState(null);

  useEffect(() => {
    let url;
    let dead = false;
    api.get(path, { responseType: "blob" })
      .then(({ data }) => {
        if (dead) return;
        url = URL.createObjectURL(data);
        setSrc(url);
      })
      .catch(() => { /* a missing photo must never break the page */ });
    return () => { dead = true; if (url) URL.revokeObjectURL(url); };
  }, [path]);

  if (!src) {
    return <div className={`${className} animate-pulse bg-slate-200`} data-testid={testId} />;
  }
  return <img src={src} alt={alt} className={className} data-testid={testId} />;
};
